export default __webpack_public_path__ + "static/media/CDC.416f0436.svg";